import { useState } from 'react';

function SignatureField({ label, value, onChange, required = false }) {
  const [typedName, setTypedName] = useState(value || '');

  const handleChange = (e) => {
    setTypedName(e.target.value);
    onChange(e.target.value);
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type="text"
        value={typedName}
        onChange={handleChange}
        placeholder="Type full name as signature"
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        required={required}
      />
      <p className="text-xs text-gray-500 mt-1">By typing your name, you agree to the consent terms</p>
    </div>
  );
}

export default SignatureField;
